export enum PROGRAM {
  MOVIE = 'MOVIE',
  SERIES = 'SERIES',
  EPISODE = 'EPISODE',
  CLIP = 'CLIP',
  SUMMARY = 'SUMMARY',
  LIVE = 'LIVE'
}
